import React from 'react';
import ModalBtn from '../../molecules/modalButton/view';
import { BiEdit } from 'react-icons/bi';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { updateSpendType, deleteSpendType } from '../../../usecases/spend-type-usecase';
import SpendTypeForm from '../SpendTypeForm/view';

function EditSpendType({ data }) {

    function handleSubmit(payload) {
        updateSpendType(data.id, payload).then(() => {
            dispatchCustomEvent("popup", { message: "Tipo de Gasto actualizado correctamente", type: "info" });
            dispatchCustomEvent("close-edit-spend-" + data.id + "-modal", []);
            dispatchCustomEvent("modal-close-edit-spend-" + data.id, []);
            dispatchCustomEvent("reload-spend-types", null);
            dispatchCustomEvent("loading-btn", null); 
        }).catch((error) => {
            const err = error.response?.data?.error;
            const messages = {
                "bad_request": "Solicitud inválida. Verifique los datos.",
                "SpendType name must be unique for the given user.": "Ya existe un tipo de gasto con este nombre para el usuario.",
            };
            dispatchCustomEvent("popup", { message: messages[err] || "Error al actualizar tipo de gasto", type: "error" });
            dispatchCustomEvent("loading-btn", null); 
        });
    }

    function handleDelete() {
        deleteSpendType(data.id).then(() => {
            dispatchCustomEvent("close-edit-spend-" + data.id + "-modal", []);
            dispatchCustomEvent("modal-close-edit-spend-" + data.id, []);
            dispatchCustomEvent("popup", { message: "Tipo de Gasto eliminado correctamente", type: "info" });
            dispatchCustomEvent("reload-spend-types", null);
            dispatchCustomEvent("loading-btn", null); 
        }).catch((error) => {
            console.error("Error deleting spend type:", error);
            dispatchCustomEvent("popup", { message: "Error al eliminar tipo de gasto", type: "error" });
            dispatchCustomEvent("loading-btn", null); 
        });
    }

    return (
        <ModalBtn 
            id={'edit-spend-'+data.id}
            title={<BiEdit />}  
            type="action"
            style={{ width: '780px', maxWidth: '95vw' }}
        >
            <SpendTypeForm
                initialData={data}
                onSubmit={handleSubmit}
                loadingId="spend-type-edit"
                title={`Editar Tipo de Gasto: ${data?.name || ''}`}
                submitLabel="Guardar Cambios"
                showDelete={true}
                onDelete={handleDelete}
            />
        </ModalBtn>
    );
}

export default EditSpendType;
